import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/apiClient";
import { hexToHsl } from "@/lib/img";

const DEFAULTS = {
  platform_name: "NexusLMS", tagline: "Training Platform", logo_url: "",
  primary_color: "#2563EB",
  shop_hero_title: "Professional courses you can enrol in today",
  shop_hero_subtitle: "Choose a course, pay securely, and we'll email your access link instantly.",
};

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const apply = useCallback((b) => {
    setBranding(b);
    const hsl = hexToHsl(b.primary_color);
    if (hsl) {
      document.documentElement.style.setProperty("--primary", hsl);
      document.documentElement.style.setProperty("--ring", hsl);
    }
    document.title = b.platform_name || "NexusLMS";
    if (b.logo_url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = b.logo_url;
    }
  }, []);

  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/branding"); apply({ ...DEFAULTS, ...data }); }
    catch (e) {}
  }, [apply]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BrandingContext.Provider value={{ branding, setBranding: apply, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext) || { branding: DEFAULTS, refresh: () => {} };
